
import { LucideIcon } from "lucide-react"

interface UsageBarProps {
  current: number
  max: number
  label: string
  icon: LucideIcon
}

export const UsageBar = ({ current, max, label, icon: Icon }: UsageBarProps) => {
  const percentage = max === -1 ? 0 : Math.min(100, (current / max) * 100)
  const isUnlimited = max === -1

  return (
    <div className="flex items-center gap-2 text-xs w-full max-w-[140px]">
      <Icon className="h-3 w-3 text-muted-foreground shrink-0" />
      <div className="flex-1 flex flex-col gap-0.5">
        <div className="flex justify-between text-[10px] text-muted-foreground">
          <span>{label}</span>
          <span>{current} / {isUnlimited ? '∞' : max}</span>
        </div>
        <div className="h-1 w-full bg-muted rounded-full overflow-hidden">
          <div
            className={`h-full rounded-full ${percentage > 90 ? 'bg-red-500' : 'bg-primary/60'}`}
            style={{ width: isUnlimited ? '100%' : `${percentage}%` }}
          />
        </div>
      </div>
    </div>
  )
}
